import { POST } from '@/api'
import { trim } from 'lodash'

const MEMO_DEFAULT = {
  date: '',
  contents: '',
}

export default {
  namespaced: true,
  state: {
    ...MEMO_DEFAULT,
    origin: {
      ...MEMO_DEFAULT,
    },
    busy: false,
    show: false,
  },
  mutations: {
    set(state, { date, contents }) {
      state.origin = { date, contents }
      state.date = date || ''
      state.contents = contents || ''
    },
    update(state, { date, contents }) {
      state.date = date || ''
      state.contents = contents || ''
    },
    reset(state) {
      const { date, contents } = state.origin
      state.date = date || ''
      state.contents = contents || ''
    },
    busy(state, busy) {
      state.busy = busy
    },
    show(state, show) {
      state.show = show
    },
  },
  getters: {
    hasMemo(state) {
      return !!state.origin.contents
    },
    getMemo(state) {
      return state.origin.contents
    },
  },
  actions: {
    async get(store, date) {
      const { state, commit } = store
      if (state.busy) return false
      commit('busy', true)

      const { status, message, data } = await POST('/api/web/memo', { date })
      if (data && status === 200) {
        commit('set', { date, contents: data.memo.contents })
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
    async save(store) {
      const { state, commit } = store
      if (state.busy) return false
      commit('busy', true)

      const req = {
        date: state.date,
        contents: trim(state.contents).length ? state.contents : null,
      }

      const { status, message } = await POST('/api/web/memo/regist', req)
      if (status === 200) {
        commit('set', req)
      } else {
        commit('app/error', { status, message }, { root: true })
      }
      commit('busy', false)
      return status === 200
    },
  },
}
